module.exports = __webpack_public_path__ + "img/jobs_i1.a3259fbd.png";